var _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _path8, _ellipse2, _path9, _path10, _path11, _ellipse3, _path12, _ellipse4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationActivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.125 34.5677C217.131 41.023 239.34 69.3018 238.996 97.1839C238.658 125.005 215.764 152.43 196.606 178.823C177.503 205.219 162.244 230.6 142.931 231.945C123.595 233.269 100.235 210.531 80.9049 195.449C61.5144 180.37 46.1985 172.939 33.006 159.686C19.8134 146.432 8.79826 127.349 11.3774 110.263C13.9565 93.1763 30.1366 78.0971 47.0593 69.87C64.0395 61.5857 81.705 60.1568 106.473 51.7582C131.241 43.3596 163.092 28.0653 190.125 34.5677Z",
    fill: "#E7EEF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4545 199L53 202.858L63.6923 216L67 213.257L61.9091 201.563L57.4545 199Z",
    fill: "#3A4944"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.401 186L138 192.779L146.444 207L150 206.008L147.668 187.447L141.401 186Z",
    fill: "#3A4944"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181,
    cy: 90,
    rx: 5,
    ry: 4,
    fill: "#E19566"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.999 94C109.649 97.3778 58 199.413 58 199.413L63.8421 203L132 128.798L111.999 94Z",
    fill: "#B99A78"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.381 69C157.75 70.1774 161.762 74.7561 163.074 75.5892C164.385 76.4223 179.424 85.8551 182.245 86.6882C185.066 87.5213 179.072 90 179.072 90C179.072 90 159.479 85.6313 158.031 84.6605C156.583 83.6897 148 76.7425 148 74.88C148 73.0175 156.381 69 156.381 69Z",
    fill: "#E19566"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.057 60.164C149.503 55.3974 158.185 66.7029 157.997 68.3652C157.809 70.0274 151.668 77 147.776 77C146.61 77 141.935 63.5126 145.057 60.164Z",
    fill: "#FDD484"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.421 95C110.404 96.3534 106 107.181 106 110.903C106 136.279 143.884 142.864 149.325 142.864C148.539 146.406 140.205 186.643 140.598 187.526C140.991 188.409 147.905 190.213 149.325 189.979C154.746 187.032 172.244 145.993 170.93 140.157C169.083 131.979 140.1 108.06 135.912 105.678C131.725 103.296 111.421 95 111.421 95Z",
    fill: "#C9AA89"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.329 50C165.586 50 142.92 104.717 137.773 107.683C134.374 109.638 113.299 102.204 111.042 94.7464C110.27 92.1996 120.162 50 136.329 50Z",
    fill: "#FFD98F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.402,
    cy: 112.765,
    rx: 5.24761,
    ry: 3.9153,
    transform: "rotate(67 119.402 112.765)",
    fill: "#E9A174"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.771 59.727C112.266 60.8674 101 66.6497 101.096 67.851C102.252 82.3816 113.48 103.628 115.35 107.326C117.22 111.024 120.935 112.327 121.491 111.868C122.047 111.408 121.846 97.3661 113.599 76.3415C115.782 74.9604 123.267 72.8715 123.497 71.6527C123.727 70.434 114.771 59.727 114.771 59.727Z",
    fill: "#E9A174"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.31 54.333C144.262 64.4285 124.467 75.1722 122.495 74.7561C120.523 74.3401 112.394 61.1686 112.942 58.7668C113.491 56.3651 132.041 46.6772 137.31 54.333Z",
    fill: "#FFDE9C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.969 36C138.434 38.1089 134.785 50.183 135.01 50.8231C135.235 51.4631 140.257 54.2863 142.185 53.9763C142.26 53.0566 143.078 48.1313 144.755 45.1701C146.431 42.2088 138.969 36 138.969 36Z",
    fill: "#E19566"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.236,
    cy: 35.57,
    rx: 11.701,
    ry: 7.7753,
    transform: "rotate(-84.2321 146.236 35.57)",
    fill: "#E9A174"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.41 36C136.578 35.5425 135 32.8486 135 30.3452C135 26.4282 138.902 24.198 141.533 23.0385C143.524 22.1458 145.216 18 149.749 18C153.365 18 153.606 21.6438 155.27 21.7836C159.581 22.1426 162 22.3046 162 25.4402C162 27.7434 159.048 34.0176 153.025 34.0176C153.025 32.8549 152.635 29.9672 151.99 28.5789C148.371 28.76 145.425 33.414 140.406 33.395C139.33 33.3759 137.41 36 137.41 36Z",
    fill: "#7E5933"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.5,
    cy: 36,
    rx: 2.5,
    ry: 3,
    fill: "#E9A174"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationActivity);
export default __webpack_public_path__ + "static/media/IllustrationActivity.969d6acd706634dfc6ac6b66d201c6b5.svg";
export { ForwardRef as ReactComponent };